import { render, staticRenderFns } from "./LectureTextView.vue?vue&type=template&id=840eeed2&"
import script from "./LectureTextView.vue?vue&type=script&lang=ts&"
export * from "./LectureTextView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports